/**
 * 下拉数据 store 模块
 * 功能：保存通用下拉列表、仓库 ID/名称、打印数据
 */
import { dropDownList } from "@/api/user";
const menuList = {
  state: {
    dropList: {},
    warehouseId: 1,
    warehouseName: "",
    printData: {},
  },
  getters: {
    dropList: (state) => state.dropList,
    warehouseId: (state) => state.warehouseId,
    warehouseName: (state) => state.warehouseName,
    printData: (state) => state.printData,
  },
  mutations: {
    SET_DROP_LIST: (state, data) => {
      state.dropList = data;
    },
    SET_WAREHOUSEID: (state, data) => {
      state.warehouseId = data;
    },
    SET_WAREHOUSE_NAME: (state, data) => {
      state.warehouseName = data;
    },
    SET_PRINT_DATA: (state, data) => {
      state.printData = data;
    },
  },
  actions: {
    /** 拉取通用下拉列表数据并存入 state */
    getDropListTwo: ({ commit }, data) => {
      dropDownList(data).then((result) => {
        if (result.code == 200) {
          commit("SET_DROP_LIST", result.data);
        } else {
          commit("SET_DROP_LIST", {});
        }
      });
    },
  },
};

export default menuList;
